import { render } from "./pageExistente2.vue?vue&type=template&id=5c094ffe&scoped=true"
import script from "./pageExistente2.vue?vue&type=script&lang=js"
export * from "./pageExistente2.vue?vue&type=script&lang=js"

import "./pageExistente2.vue?vue&type=style&index=0&id=5c094ffe&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/caxias-pedal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c094ffe"]])

export default __exports__